import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ROUTE_PATH } from '../../constants/routes';

export const PasswordResetCompleteForm = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* ボックス1：パスワードの設定 */}
      <section className="l-card">
        <div className="l-text-group l-text-group--white">
          <p className="l-text">
            {t('passwordReset.complete.title')}
          </p>
        </div>
      </section>

      {/* ボックス2：アクション */}
      <section className="l-card l-mt30">
        <div className="l-card__body">
          <Link className="link-button link-button--signup-first" to={ROUTE_PATH.LOGIN}>
            {t('passwordReset.complete.loginButton')}
          </Link>
        </div>
      </section>
    </>
  );
};
